// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".alert[data-v-2ffefd67]{margin-bottom:0}.message[data-v-2ffefd67]{font-weight:700}.message[data-v-2ffefd67]:last-child{margin-bottom:0}dl[data-v-2ffefd67]{font-size:.9em}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
